import { useTranslation } from "react-i18next"

function Loader() {
    const { t } = useTranslation();
    return (
        <div className='loader'>
            <div>
                <div className="loader-icon">
                </div>
                <h3 className="mt-4">{t("loading-span")}</h3>
            </div>
        </div>
    )
}
export default Loader